<template>
    <div class="ader-result">
        <p class="result-icon"><img :src="iconSucc" /></p>
        <h3 class="result-title">提交审核成功</h3>
        <p class="result-desc">恭喜您，广告主已经提交审核成功，请耐心等待审核</p>
        <p class="result-btn">
            <el-button type="primary" plain @click="toList">返回列表</el-button> &nbsp;
            <el-button plain @click="toDetail">查看详情</el-button>
        </p>
    </div>
</template>

<script>
import IconSucc from '@/assets/image/icon/success-icon_140_140.png';

export default {
    name: 'AdvertiserManagePrivateInitAderResult',
    data () {
        return {
            iconSucc: IconSucc,
            customerId: '',
            owner: ''
        };
    },
    methods: {
        toDetail () {
            if (!this.customerId) return;
            const { customerId, owner } = this;
            const type = '1';
            this.$router.replace({ name: 'AdvertiserManageDetail', query: { customerId, owner, type } });
        },
        toList () {
            this.$router.replace({ name: 'AdvertiserManagePrivateList' });
        }
    },
    created () {
        this.customerId = this.$route.query.customerId || '';
        this.owner = this.$route.query.owner || '';
    }
};
</script>

<style lang="less" scoped>
.ader-result {
    text-align: center;

    .result-icon {
        img {
            width: 70px;
        }
    }
    .result-title {
        font-size: 22px;
        padding: 16px 0 0 0;
    }
    .result-desc {
        font-size: 14px;
        color: #666;
        margin-bottom: 50px;
    }
}
</style>
